const finished_questionnaires = {
  'finished_questionnaires_title': "Vous avez fini de répondre à tous les questionnaires en cours",
  'finished_questionnaires_button': "Accueil",
  'finished_questionnaire_title': "Vous avez atteint la fin du questionnaire",
}


export default finished_questionnaires;
